// Protection against spelling errors in conditional logic
export const typesOfData = {
  default: "unknown",
  checks: "checks",
  condition: "condition",
  tyreSets: "tyreSets"
}

// A generic class for processing of fetched test data.
// this class should not be used as is. Use subclasses.
export default class StatusItem {
  constructor(dataObject) {
    Object.assign(this, dataObject)
    this.key = Math.random()
    this.itemType = typesOfData.default
  }

  // enables use if description getter for all test data
  set description(name) { this.name = name }
  get description() { return this.name || "" }

  // get numberOfNotes() { return this.notes.length || 0 }
  get numberOfNotes() { return this.notes ? this.notes.length : 0 }
  get indicatorMax() { return 3 }
  get indicatorCurrent() { return 1 }
  get result() { return "unknown result" }

  get styleAsWarning() {
    switch (this.itemType) {
      case typesOfData.checks || typesOfData.condition:
        return this.numberOfNotes > 0
      default:
        return false
    }
  }
}

